import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "What business problems can NLP solutions solve for my company?",
    answer: `<p>NLP solutions can address various business challenges, including automating customer support with chatbots, extracting insights from unstructured data, improving search functionality, detecting fraud, analyzing customer sentiment, and personalizing content for targeted marketing.</p>`,
  },
  {
    question: "How do NLP solutions integrate with existing systems?",
    answer: `<p>NLP solutions are designed to seamlessly integrate with your existing IT infrastructure. Our team assesses your current systems and utilizes APIs, middleware, and custom connectors to ensure smooth integration without disrupting your operations.</p>`,
  },
  {
    question: "What kind of data is required to develop effective NLP models?",
    answer: `<p>Effective NLP models require large datasets of text, including documents, emails, chat logs, social media posts, and other unstructured data. The quality and relevance of the data significantly impact the model's performance. We also support data preprocessing and annotation to enhance data quality.</p>`,
  },
  {
    question:
      "How do you ensure the security and privacy of sensitive data in NLP projects?",
    answer: `<p>We implement stringent security protocols, including encryption, access control, and compliance with industry standards (e.g., GDPR, HIPAA) to protect sensitive data. Our solutions are designed to maintain data confidentiality and integrity throughout the project lifecycle.</p>`,
  },
  {
    question:
      "What is the typical timeline for developing and deploying an NLP solution?",
    answer: `<p>The timeline for NLP solution development and deployment varies based on project complexity and scope. A typical project might take from a few weeks to several months. Our process includes requirement analysis, data collection and preparation, model development, integration, testing, and deployment.</p>`,
  },
  {
    question:
      "How do you ensure the accuracy and continuous improvement of NLP models?",
    answer: `<p>We use advanced machine learning techniques and continuous training processes to ensure high accuracy of NLP models. Regular updates and retraining with new data help maintain and improve model performance. We also provide monitoring and maintenance services to adapt to changing business needs.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>NLP Development Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
